import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const saveQuotesAndArticles = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN); 
    const response = await axios.post(`${API_URL}/company/myquotes/generateMyquotes`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateQuotesAndArticles = async (uuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/myquotes/update/${uuid}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const deleteQuotesAndArticles = async (uuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/myquotes/remove/${uuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};